const autoCompletePosition = () => {
	const body = document.querySelector(`body`) as HTMLElement;
	const kinderBlancHighlights = document.querySelector(
		`.hp-kinder__highlight`
	) as HTMLElement;
	if (kinderBlancHighlights) {
		const autoCompleteList = document.getElementById(
			`ui-id-2`
		) as HTMLElement;
		if (autoCompleteList) {
			body.classList.add(`autocomplete-center`);
		}
	}
};

window.addEventListener(`load`, () => {
	autoCompletePosition();
});
